// extracted by mini-css-extract-plugin
export default {"pageDescription":"ProjectsSheetsPage_pageDescription__wPD98"};